<template>
<div>
    <!-- Resource Matching Services Section -->
    <section v-if="showAnalysis" class="related-services">
        <div class="container">
            <div class="section-title" style="margin-bottom:0px">
                <div class="title-decoration"></div>
                <h3>Strategic Resource Access</h3>
            </div>
            <div class="services-grid">
                <!-- 响应式容器 -->
                <div class="responsive-table">
                <!-- 表头（第1个Div：模拟表头行） -->
                <div class="table-header">
                    <div class="table-cell cell-1">Service</div>
                    <div class="table-cell cell-2">Value</div>
                    <div class="table-cell cell-3">When You Need It</div>
                </div>

                <!-- 表体（第2个Div：包裹所有数据行） -->
                <div class="table-body">
                    <!-- 数据行（每个行是一个Div） -->
                    <div class="table-row" v-for="(item, index) in ResourceMatchingData" :key="index" :class="{ 'even-row': index % 2 === 1 }">
                    <!-- 单元格（第3个Div：每个单元格是独立Div） -->
                    <div class="table-cell cell-1" data-label="Service">
                        {{ item.serviceType }}
                    </div>
                    <div class="table-cell cell-2" data-label="Value">
                        {{ item.description }}
                    </div>
                    <!-- 最后一列：对勾紧跟文字前（简化结构） -->
                    <div class="table-cell cell-3" data-label="When You Need It">
                        <span class="check-icon">✓</span>
                        <span class="scenarios-text">{{ item.scenarios }}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section v-if="showAnalysis" class="services-process">
        <div class="container">
            <div class="section-title">
                <h3>Service Process</h3>
            </div>
            <!-- 动态渲染图标区域 -->
            <div class="services-process_pic">
                <div class="process-item" v-for="(item, index) in processSteps" :key="index">
                    <div class="process-icon">
                        <!-- 图片路径支持相对路径/绝对路径，Vue 2 需确保路径正确（如放在 assets 目录） -->
                        <img :src="require(`../assets/${item.icon}`)" :alt="`${item.title} Icon`">
                    </div>
                    <!-- 最后一个步骤不显示横线 -->
                    <div class="process-line" v-if="index < processSteps.length - 1"></div>
                </div>
            </div>

            <!-- 动态渲染文案区域 -->
            <div class="services-process_item">
                <div class="process-text-item" v-for="(item, index) in processSteps" :key="index">
                <h4>{{ item.title }}</h4>
                <p>{{ item.desc }}</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Service Packages Section -->
    <section v-if="showAnalysis" class="service-packages">
        <div class="container">
            <div class="section-title">
                <div class="title-decoration"></div>
                <h3>Service Packages</h3>
            </div>
            <div class="packages-grid">
                <div class="packages-card">
                    <!-- 套餐标题区域 -->
                    <div class="package-header">
                        <h3 class="package-title">Starter Package</h3>
                        <span class="package-tag">Special Offer</span>
                    </div>
                    <!-- 价格区域 -->
                    <div class="package-price">
                        <span class="price-label">Starting at</span>
                        <span class="price-old">700 €</span>
                        <span class="price-new">200 €</span>
                    </div>
                    <!-- 描述区域 -->
                    <p class="package-desc">For first-time users / small-scale needs</p>
                    <!-- 按钮区域 -->
                    <button class="package-btn" @click="$scrollToRefById('global-contact-us', {}, true)">Get Started</button>
                    <!-- 服务列表区域（优化后） -->
                    <ul class="package-services">
                        <li class="service-item">
                            <i class="service-icon icon-consultant">
                                <img src="../assets/icon_package1.png"/>
                            </i>
                            <span class="service-text">1 dedicated advisor session: 1-on-1 needs mapping (call/online)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-resource">
                                <img src="../assets/icon_package2.png"/>
                            </i>
                            <span class="service-text">3 targeted resource matches (by country/industry)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-matchmaking">
                                <img src="../assets/icon_package3.png"/>
                            </i>
                            <span class="service-text">1 virtual matchmaking meeting (platform-coordinated)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-minutes">
                                <img src="../assets/icon_package4.png"/>
                            </i>
                            <span class="service-text">Meeting minutes (optional)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-followup">
                                <img src="../assets/icon_package5.png"/>
                            </i>
                            <span class="service-text">7×12-hour advisor follow-up</span>
                        </li>
                    </ul>
                </div>
                <div class="packages-card">
                    <!-- 套餐标题区域 -->
                    <div class="package-header">
                        <h3 class="package-title">Standard Package</h3>
                    </div>
                    <!-- 价格区域 -->
                    <div class="package-price">
                        <span class="price-label">Starting at</span>
                        <span class="price-new">1200 €</span>
                    </div>
                    <!-- 描述区域 -->
                    <p class="package-desc">For clear targets / deep-dive engagement</p>
                    <!-- 按钮区域 -->
                    <button class="package-btn" @click="$scrollToRefById('global-contact-us', {}, true)">Get Started</button>
                    <!-- 服务列表区域（优化后） -->
                    <ul class="package-services">
                        <li class="service-item">
                            <i class="service-icon icon-consultant">
                                <img src="../assets/icon_package1.png"/>
                            </i>
                            <span class="service-text">1 in-depth needs diagnosis + overseas strategy recommendations</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-resource">
                                <img src="../assets/icon_package2.png"/>
                            </i>
                            <span class="service-text">6–8 high-quality resource matches (pre-screened & vetted)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-matchmaking">
                                <img src="../assets/icon_package3.png"/>
                            </i>
                            <span class="service-text">2 virtual matchmaking sessions (type/partner selectable)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-minutes">
                                <img src="../assets/icon_package4.png"/>
                            </i>
                            <span class="service-text">Basic translation support / meeting minutes</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-followup">
                                <img src="../assets/icon_package5.png"/>
                            </i>
                            <span class="service-text">Dedicated advisor: full journey support</span>
                        </li>
                    </ul>
                </div>
                <div class="packages-card">
                    <!-- 套餐标题区域 -->
                    <div class="package-header">
                        <h3 class="package-title">Premium Package</h3>
                    </div>
                    <!-- 价格区域 -->
                    <div class="package-price">
                        <span class="price-label">Starting at</span>
                        <span class="price-new">3600 €</span>
                    </div>
                    <!-- 描述区域 -->
                    <p class="package-desc">For mid-to-large enterprises / strategic expansion</p>
                    <!-- 按钮区域 -->
                    <button class="package-btn" @click="$scrollToRefById('global-contact-us', {}, true)">Get Started</button>
                    <!-- 服务列表区域（优化后） -->
                    <ul class="package-services">
                        <li class="service-item">
                            <i class="service-icon icon-consultant">
                                <img src="../assets/icon_package1.png"/>
                            </i>
                            <span class="service-text">1-on-1 senior advisor: full-service engagement (industry manager)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-resource">
                                <img src="../assets/icon_package2.png"/>
                            </i>
                            <span class="service-text">10+ resource matches (including government/parks/leading firms)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-matchmaking">
                                <img src="../assets/icon_package3.png"/>
                            </i>
                            <span class="service-text">3–5 virtual sessions (curated for efficiency)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-minutes">
                                <img src="../assets/icon_package6.png"/>
                            </i>
                            <span class="service-text">On-site visit coordination (reception, translation, itinerary guidance)</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-minutes">
                                <img src="../assets/icon_package4.png"/>
                            </i>
                            <span class="service-text">Meeting minutes + key resource analysis report</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-followup">
                                <img src="../assets/icon_package5.png"/>
                            </i>
                            <span class="service-text">Priority access to government/investment/industrial fund resources</span>
                        </li>
                    </ul>
                </div>
                <div class="packages-card">
                    <!-- 套餐标题区域 -->
                    <div class="package-header">
                        <h3 class="package-title">【VIP Global Direct + 】</h3>
                    </div>
                    <a>One-on-One Tailored Solutions</a>
                    <!-- 价格区域 -->
                    <div class="package-price">
                        <span class="price-new">Custom pricing</span>
                    </div>
                    <!-- 描述区域 -->
                    <p class="package-desc">For large groups, government partnerships, M&A, summits—tailored end-to-end</p>
                    <!-- 按钮区域 -->
                    <button class="package-btn" @click="$scrollToRefById('global-contact-us', {}, true)">Experience it now</button>
                    <!-- 服务列表区域（优化后） -->
                    <ul class="package-services">
                        <li class="service-item">
                            <i class="service-icon icon-consultant">
                                <img src="../assets/icon_package1.png"/>
                            </i>
                            <span class="service-text">Government leadership / industrial fund connections</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-resource">
                                <img src="../assets/icon_package2.png"/>
                            </i>
                            <span class="service-text">Strategic investment / tech cooperation / joint expansion</span>
                        </li>
                        <li class="service-item">
                            <i class="service-icon icon-matchmaking">
                                <img src="../assets/icon_package3.png"/>
                            </i>
                            <span class="service-text">Unlimited resources & sessions: fully customized</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <!-- Related Services Section -->
    <section v-if="showAnalysis" class="related-section">
        <div class="container">
            <div class="section-title" style="margin-bottom:0px">
                <h2>Related Services</h2>
            </div>
            <div class="related-section__grid">
                <!-- 动态渲染卡片：循环 relatedCards 数组 -->
                <div class="related-section__card" :class="`related-section__card--${card.type}`" v-for="(card, index) in relatedCards" :key="index">
                    <div class="related-section__card-header">{{ card.title }}</div>
                    <ul class="related-section__card-body">
                        <!-- 动态渲染卡片列表项 -->
                        <li v-for="(item, idx) in card.items" :key="idx">
                        {{ item }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <!-- Success Stories Section -->
    <section v-if="showAnalysis" class="success-stories">
        <div class="container">
            <div class="section-title">
                <h2>Success Stories</h2>
            </div>
            <div class="stories-grid">
                <div class="story-card" v-for="story in successStories" :key="story.id">
                    <div class="story-content">
                        <h3>{{ story.title }}</h3>
                        <div class="story-description">
                            <p>{{ story.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

  <script>
  export default {
    name: 'StaticData',
    props: {
        showAnalysis: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        contactUs() {
            this.$emit('scrollToContact');
        }
    },
    data() {
        return {
            // 卡片配置数组：后续修改/新增/删除卡片，仅需操作此数组
            relatedCards: [
                {
                type: 'blue', // 卡片颜色类（对应原 related-section__card--blue）
                title: 'Market Entry into China', // 卡片标题
                items: [ // 卡片列表项
                    'City/Province Investment Promotion Materials (PDF + Interpretation)',
                    'Supply Chain Procurement, Channel & Agent Matching',
                    'Access to Industry Exhibitions & Events (Canton Fair, CHTF, etc)',
                    'Brand Localization & E-commerce Channel Development',
                    'Specialized Training to Enhance Practical Capabilities for Entering the Chinese Market'
                ]
                },
                {
                type: 'dark-blue', // 卡片颜色类（对应原 related-section__card--dark-blue）
                title: 'Market Entry Support for Southeast Asia',
                items: [
                    'Investment Policy Interpretation (Vietnam, Indonesia, Thailand, Singapore)',
                    'Industrial Park & Supply Chain Recommendations',
                    'Company Registration, Tax, and Employment Compliance',
                    'Customized Inspection Itineraries & Accompanied Liaison',
                    'Specialized Training to Enhance Capabilities for Entering the Southeast Asian Market'
                ]
                },
                {
                type: 'blue',
                title: 'Partnership Facilitation & Advisory',
                items: [
                    'Partner/Client Lead List (Unlock via Payment)',
                    'Online Advisory Session Booking (15-30 min)',
                    'Project-based Hand-holding (Planning + Execution + Review)',
                    'Compliance/Legal/Tax/Data Privacy Advisory',
                    'Specialized Training to Enhance Market Competitiveness'
                ]
                },
                {
                type: 'dark-blue',
                title: 'Specialized Training',
                items: [
                    'Understanding the Chinese Approach to Strategic Thinking',
                    'Learning Chinese Organizational Culture',
                    'Understanding the Market & Customer Ecosystem',
                    'Comprehending the Striver Culture & HR Mechanisms',
                    'Mastering the Chinese Efficient Operation System'
                ]
                }
            ],
            // 步骤配置数组：后续修改/新增步骤，仅需修改此数组
            processSteps: [
                {
                    icon: 'icon_process1.png', // 图片文件名（放在 assets 目录下）
                    title: 'Submit Requirements',
                    desc: 'Share your industry, target markets, and specific needs—our advisors respond promptly'
                },
                {
                    icon: 'icon_process2.png',
                    title: 'Precise Matching',
                    desc: 'We screen and connect you with the most suitable resources, ensuring high-quality matches'
                },
                {
                    icon: 'icon_process3.png',
                    title: 'Online Negotiation',
                    desc: '1-on-1 or multi-party virtual sessions for efficient communication and initial validation'
                },
                {
                    icon: 'icon_process4.png',
                    title: 'Follow-up',
                    desc: 'For deeper collaboration, we assist with site visits, translation, logistics, and end-to-end support'
                }
            ],
            ResourceMatchingData: [
                {
                    serviceType: "Industrial Park Access",
                    description: "Direct access to industrial parks, incentives, and prime sites",
                    scenarios: "Plant&Office Setup, regional HQ"
                },
                {
                    serviceType: "Supply Chain Integration",
                    description: "Source and integrate suppliers, manufacturers, and tech partners",
                    scenarios: "Cost reduction, supply chain resilience, technology cooperation"
                },
                {
                    serviceType: "Go-to-Market Channels",
                    description: "Deploy distributors, agents, and digital platforms",
                    scenarios: "Rapid market entry, sales scaling"
                },
                {
                    serviceType: "Government Relations & Investment",
                    description: "Activate government bodies and SEZs for policy support",
                    scenarios: "Subsidies, approvals, incentives"
                },
                {
                    serviceType: "Supplier/Purchasing Liaison",
                    description: "Match global buyers with vetted suppliers",
                    scenarios: "Strategic procurement, trade partnerships"
                },
                {
                    serviceType: "Customized Matchmaking",
                    description: "Tailored solutions for specialized needs—expo partnerships, associations, networks",
                    scenarios: "Unique requirements, niche opportunities"
                }
            ],
            services: [{
                    id: 'market-diagnosis',
                    title: 'Market Diagnosis',
                    description: 'Input your industry, product, and objectives to get recommendations for the most suitable countries and cities',
                    icon: 'fas fa-search',
                    features: [
                        'Get recommended countries & cities',
                        'Receive rationale & risk assessment',
                        'Customized market insights'
                    ]
                },
                {
                    id: 'market-entry',
                    title: 'Market Entry & Inspection',
                    description: 'Comprehensive support for entering new markets with policy interpretation and compliance registration',
                    icon: 'fas fa-plane',
                    features: [
                        'Policy interpretation',
                        'Compliance registration',
                        'Industrial park recommendations',
                        'Itinerary arrangement'
                    ]
                },
                {
                    id: 'partnership',
                    title: 'Partnership Facilitation',
                    description: 'Connect with reliable partners through our extensive enterprise resource pool',
                    icon: 'fas fa-handshake',
                    features: [
                        'Supply chain procurement',
                        'Channel/agent partnerships',
                        'ESB cooperation',
                        'Access to enterprise resource pool'
                    ]
                }
            ],

            // 相关服务
            relatedServices: [{
                    id: 1,
                    title: 'Market Entry into China',
                    features: [
                        'City/Province Investment Promotion Materials (PDF + Interpretation)',
                        'Supply Chain Procurement, Channel & Agent Matching',
                        'Access to Industry Exhibitions & Events (Canton Fair, CHTF, etc)',
                        'Brand Localization & E-commerce Channel Development',
                        'Specialized Training to Enhance Practical Capabilities for Entering the Chinese Market'
                    ]
                },
                {
                    id: 2,
                    title: 'Market Entry Support for Southeast Asia',
                    features: [
                        'Investment Policy Interpretation (Vietnam, Indonesia, Thailand, Singapore)',
                        'Industrial Park & Supply Chain Recommendations',
                        'Company Registration, Tax, and Employment Compliance',
                        'Customized Inspection Itineraries & Accompanied Liaison',
                        'Specialized Training to Enhance Capabilities for Entering the  Southeast Asian Market'
                    ]
                },
                {
                    id: 3,
                    title: 'Partnership Facilitation & Advisory',
                    features: [
                        'Partner/Client Lead List (Unlock via Payment)',
                        'Online Advisory Session Booking (15-30 min)',
                        'Project-based Hand-holding (Planning + Execution + Review)',
                        'Compliance/Legal/Tax/Data Privacy Advisory',
                        'Specialized Training to Enhance Market Competitiveness'
                    ]
                },
                {
                    id: 4,
                    title: 'Specialized Training',
                    features: [
                        'Understanding the Chinese Approach to Strategic Thinking',
                        'Learning Chinese Organizational Culture',
                        'Understanding the Market & Customer Ecosystem',
                        'Comprehending the Striver Culture & HR Mechanisms',
                        'Mastering the Chinese Efficient Operation System'
                    ]
                }
            ],

            // 特色文档
            featuredDocuments: [{
                    id: 1,
                    title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                    summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                    date: 'Last Updated: August 20, 2025',
                    url: '/documents/sea-investment-guide.pdf'
                },
                {
                        id: 2,
                        title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                        image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                        summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                        date: 'Last Updated: August 20, 2025',
                        url: '/documents/sea-investment-guide.pdf'
                    },
                    {
                            id: 3,
                            title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                            image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                            summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                            date: 'Last Updated: August 20, 2025',
                            url: '/documents/sea-investment-guide.pdf'
                        },
                        {
                                id: 4,
                                title: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                                image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                                summary: 'Shenzhen Industrial Investment Promotion Guide (2025)',
                                date: 'Last Updated: August 20, 2025',
                                url: '/documents/sea-investment-guide.pdf'
                            }
            ],

            // 成功案例
            successStories: [{
                    id: 1,
                    title: 'EU → SHENZHEN',
                    description: 'A European new energy company established its Asia-Pacific headquarters in Shenzhen, becoming operational within 6 months and achieving local supply chain integration within 12 months',
                    image: 'https://images.unsplash.com/photo-1531299204812-e6d44d9a185c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    id: 2,
                    title: 'US → VIETNAM + CHINA',
                    description: 'A US components manufacturer: Set up a factory in Vietnam, sourced key molds from China, achieving a 12% cost reduction',
                    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                },
                {
                    id: 3,
                    title: 'JAPAN → SHANGHAI',
                    description: 'A Japanese consumer electronics brand entered tier-1 city distribution channels, implementing an integrated online and offline sales model',
                    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
                }
            ]
        }
    }
}
</script>

<style scoped>
/* 基础样式 */
.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

/* Hero Section */
.hero {
    background: url('../assets/home_banner.jpg');
    background-size: cover;
    background-position: center;
    color: white;
    padding: 100px 0;
    text-align: center;
}

.hero h1 {
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1.2;
}

.hero p {
    font-size: 16px;
    max-width: 700px;
    margin: 0 auto 27px;
    line-height: 1.5;
}

/* Stats Section */
.stats {
    padding: 60px 0;
    background-color: #2444CB;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
}

/* Services Section */
/* Services Section - 修复响应式布局 */
.services {
    padding: 60px 0;
    background-color: white;
}

.services-wrapper {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 80px;
    align-items: center;
}

.services-content {
    display: flex;
    flex-direction: column;
}

.services-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-top: 30px;
}

.service-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.service-icon {
    width: 42px;
    height: 42px;
    /* border-radius: 100px; */
    /* border: 2px solid #DDDDDD; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* flex-shrink: 0; */
}

.service-icon img {
    width: 25px;
    height: 25px;
}

.service-text {
    flex: 1;
}

.service-title {
    font-size: 26px;
    color: #222222;
    margin-bottom: 8px;
    font-weight: 600;
}

.service-desc {
    font-size: 16px;
    color: #222222;
    line-height: 1.5;
}

.details-button {
    width: 200px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #265FFF;
    border-radius: 8px;
    margin-top: 40px;
}

.details-link {
    font-size: 14px;
    color: white;
    text-decoration: none;
    font-weight: 500;
}

.services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
    /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
    padding-top: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.services-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
}

/* Diagnosis Section */
.diagnosis {
    padding: 100px 0;
    background-color: #2444CB;
}

.diagnosis .section-title h2 {
    font-size: 44px;
    color: white;
}

.diagnosis .section-title p {
    font-size: 16px;
    color: white;
}

.title-decoration {
    height: 12px;
    width: 60px;
    background-color: #FF9E1B;
    margin-bottom: 16px;
}

.diagnosis-container {
    margin: 0 auto;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.diagnosis-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

/* 下拉框样式调整 */
.form-group {
    position: relative;
}

.form-group select {
    width: 100%;
    font-size: 16px;
    padding: 12px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    /* 移除默认箭头并添加自定义样式 */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) center;
    /* 向左移动20px */
    background-size: 16px;
    padding-right: 40px;
    /* 增加右侧内边距为箭头留空间 */
}

/* 单独设置联系表单的placeholder颜色 */
.contact-form input::placeholder,
.contact-form textarea::placeholder,
.contact-form select:invalid {
    color: #999;
}

.contact-form select option[value=""] {
    color: #999;
}

.form-buttons {
    grid-column: 1 / -1;
    display: flex;
    gap: 15px;
    margin-top: 20px;
}

.btn-primary {
    background-color: #FF9E1B;
    color: black;
    border: none;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
}

.btn-secondary {
    background-color: transparent;
    color: white;
    border: 1px solid white;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1;
}

/* Analysis Section */
.analysis-recommend {
    padding: 60px 0;
    background-color: white;
}

.analysis-recommend h3 {
    font-size: 32px;
    color: #222222;
    margin-bottom: 30px;
}

.analysis-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 44px;
}

.analysis-item {
    border: 1px solid #2444CB;
    border-radius: 8px;
    padding: 10px 0px;
    background-color: white;
    display: flex;
    flex-direction: column;
}

.analysis-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    /* height: 40px; */
    padding: 15px 20px;
}

.analysis-header img {
    height: 23px;
    width: 23px;
}

.analysis-header p {
    margin-left: 10px;
    font-family: Arial, Arial;
    font-weight: normal;
    font-size: 18px;
    color: #222222;
    line-height: 24px;
    font-style: normal;
    text-transform: none;
}

.divider {
    height: 1px;
    background-color: #2444CB;
    width: 100%;
    margin: 0 0;
}

.analysis-content {
    display: flex;
    flex-direction: column;
    padding: 25px;
    /* 增加内边距，使文字与边框距离增加 */
    font-size: 16px;
    flex: 1;
}

.content-label {
    color: #303030;
    margin-bottom: 12px;
    /* 增加标签与内容框之间的距离 */
}

.content-box {
    /* height: 50px; */
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    /* 增加内容框之间的间距 */
}

.empty-text {
    color: #999999;
}

.filled-box {
    border: 2px solid #2444CB;
    border-radius: 6px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 14px;
    padding: 10px 20px;

    height: auto; /* 不再填满父节点，让 padding 生效并扩高 */
    box-sizing: border-box;
    /* 为填充框内的文字增加内边距 */
}

.filled-box p {
    color: #2444CB;
    margin: 0;
}

.contact-link {
    display: flex;
    align-items: left;
    font-size: 14px;
    margin-top: 15px;
    /* 增加联系链接的顶部间距 */
}

.contact-link a {
    color: #265FFF;
    text-decoration: none;
}

.report-buttons {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    margin-top: 10px;
    padding: 10px 20px;
}

.btn-outline {
    background-color: white;
    border: 1px solid #265FFF;
    color: #265FFF;
    padding: 12px 24px;
    border-radius: 4px;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 800;
    font-size: 14px;
    font-style: normal;
    height: 40px;
    cursor: pointer;
    transition: all 0.3s ease;
}

/* Related Services */
.related-services {
    padding: 60px 0;
    background-color: #2444CB;
    width: 100%;
}

.related-services .section-title h3 {
    font-size: 32px;
    color: white;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
}

.services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 30px;
    width: 100%;
}

.service-card {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.card-header {
    background-color: #265FFF;
    color: white;
    padding-left: 31px;
}

.card-header h3 {
    margin: 0;
    font-size: 24px;
    font-family: Arial, Arial;
    font-weight: normal;
    height: 60px;
    display: flex;
    align-items: center;
}

.card-content {
    padding: 20px 25px 0 31px;
}

.card-content ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.card-content li {
    margin-bottom: 12px;
    padding-left: 20px;
    position: relative;
    font-size: 16px;
    line-height: 1.4;
}

.card-content li:before {
    content: "•";
    color: #265FFF;
    font-weight: bold;
    position: absolute;
    left: 0;
}

/* Featured Documents */
.featured-documents {
    padding: 60px 0;
    background-color: white;
}

.documents-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
}

.document-card {
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.document-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.document-image {
    height: 200px;
    overflow: hidden;
}

.document-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.document-summary {
    padding: 20px;
}

.document-summary p {
    margin-bottom: 10px;
    line-height: 1.5;
    font-size: 16px;
}

.document-date {
    color: #222222;
    font-size: 12px;
}

/* Success Stories */
.success-stories {
    padding: 60px 0;
    background-color: #2444CB;
}

.success-stories .section-title h2 {
    color: white;
    font-size: 32px;
}

.stories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
}

.story-card {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.story-content {
    display: flex;
    flex-direction: column;
    height: 220px;
    background: url('../assets/light_bg.png');
    background-size: cover;
    background-position: center;
    padding: 25px;
}

.story-content h3 {
    padding: 0;
    font-size: 20px;
    color: #222222;
    height: 60px;
    margin: 0;
    display: flex;
    align-items: center;
}

.story-description {
    height: 160px;
}

.story-description p {
    font-size: 18px;
    color: #222222;
    line-height: 1.4;
    margin: 0;
}

/* Contact Section */
.contact {
    padding: 60px 0;
    background-color: #022A4E;
}

.contact-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
}

.footer-links {
    display: flex;
    gap: 35px;
    margin-top: auto; /* 这将把链接推到容器底部 */
    padding-top: 30px;
}

.footer-link {
    color: #b3cde0;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;
}

.footer-link:hover {
    color: white;
}

/* 确保contact-info使用flex布局以支持底部对齐 */
.contact-info {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.contact-info .section-title h2 {
    font-size: 44px;
    color: white;
}

.contact-info .section-title p {
    color: white;
    font-size: 16px;
    line-height: 1.5;
}

.contact-details {
    margin-top: 30px;
    color: white;
}

.contact-details p {
    margin-bottom: 10px;
}

.social-links {
    margin-top: 30px;
}

.social-icons {
    display: flex;
    gap: 20px;
}

.social-icons a img {
    height: 31px;
    width: 31px;
}

.contact-form {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.contact-form h3 {
    color: #1a3a5f;
    margin-bottom: 20px;
    font-size: 24px;
}

.contact-form .form-group {
    margin-bottom: 20px;
    position: relative;
}

.contact-form input,
.contact-form select,
.contact-form textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
}

/* 为联系表单的下拉框也应用相同的样式 */
.contact-form select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: calc(100% - 12px) center;
    background-size: 16px;
    padding-right: 40px;
}

.contact-form .btn-primary {
    background-color: #265FFF;
    width: 100%;
    color: white;
}

/* Report Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.report-modal {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
}

.report-content {
    margin: 20px 0;
    line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        padding: 0 40px;
    }

    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
        /* 中等屏幕显示2列 */
    }

    .services-wrapper {
        gap: 60px;
    }

    .service-title {
        font-size: 24px;
    }
}

@media (max-width: 992px) {
    .contact-container {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .diagnosis-form {
        grid-template-columns: 1fr;
    }

    .services-wrapper {
        grid-template-columns: 1fr;
        gap: 50px;
    }

    .services-image {
        order: -1;
        /* 图片在上方 */
        max-width: 500px;
        margin: 0 auto;
    }

    .services-content {
        text-align: center;
    }

    .service-item {
        justify-content: center;
        text-align: center;
    }

    .details-button {
        margin: 40px auto 0;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 0 20px;
    }

    .hero {
        padding: 40px 0;
    }

    .hero h1 {
        font-size: 28px;
    }

    .hero p {
        font-size: 14px;
    }

    .stats,
    .diagnosis,
    .analysis-recommend,
    .related-services,
    .services-packages,
    .services-process,
    .featured-documents,
    .success-stories,
    .contact {
        padding: 40px 0;
    }

    .stats-grid {
        grid-template-columns: 1fr;
        /* 小屏幕显示1列 */
        gap: 20px;
    }

    .section-title h2 {
        font-size: 24px;
    }

    .diagnosis .section-title h2 {
        font-size: 32px;
    }

    .contact-info .section-title h2 {
        font-size: 32px;
    }

    .services {
        padding: 40px 0;
    }

    .services-wrapper {
        gap: 40px;
    }

    .services-list {
        gap: 20px;
        margin-top: 25px;
    }

    .service-item {
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 15px;
    }

    .service-title {
        font-size: 22px;
    }

    .service-desc {
        font-size: 15px;
    }

    .services-image {
        max-width: 100%;
        height: 370px;
    }

    .analysis-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .documents-grid {
        grid-template-columns: 1fr;
    }

    .stories-grid {
        grid-template-columns: 1fr;
    }

    .form-buttons {
        flex-direction: column;
    }

    .report-buttons {
        padding: 0 15px;
    }

    .contact-form {
        padding: 20px;
    }
}

@media (max-width: 576px) {
    .services-wrapper {
        gap: 30px;
    }

    .service-title {
        font-size: 20px;
    }

    .service-desc {
        font-size: 14px;
    }

    .service-icon {
        width: 38px;
        height: 38px;
    }

    .service-icon img {
        width: 18px;
        height: 18px;
    }

    .details-button {
        width: 100%;
        max-width: 200px;
    }

    .services-image {
        height: 320px;
    }
}

@media (max-width: 480px) {
    .hero h1 {
        font-size: 24px;
    }

    .service-title {
        font-size: 18px;
    }

    .service-desc {
        font-size: 14px;
    }

    .services-list {
        gap: 25px;
    }

    .service-item {
        gap: 12px;
    }

    .diagnosis .section-title h2 {
        font-size: 28px;
    }

    .contact-info .section-title h2 {
        font-size: 28px;
    }

    .social-icons {
        justify-content: center;
    }

    .details-button {
        width: 100%;
        max-width: 200px;
        margin-left: auto;
        margin-right: auto;
    }
}

/** Resource Matching Services Section  */
/* 父容器：居中 + 自适应内边距 */
.services-grid {
  width: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

/* 响应式表格容器：兜底横向滚动（极端情况） */
.responsive-table {
  width: 100%;
  max-width: 1200px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* 移动端滚动流畅 */
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 表头行（第1个Div） */
.table-header {
  display: flex;
  background-color: #1F39A7; 
  color: white;
  font-weight: 600;
  text-align: center; /* 表头文字左对齐 */
}

/* 表头单元格（子元素）：核心居中配置 */
.table-header .table-cell {
  display: flex; /* 启用 flex 实现自身内容居中 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  text-align: center; /* 兜底：应对单元格内有行内元素的情况 */
}

/* 表体（第2个Div） */
.table-body {
  display: flex;
  flex-direction: column;
}

/* 数据行（每个行是Div） */
.table-row {
  display: flex;
  width: 100%;
  background-color: #fff; /* 奇数行背景色 */
}

/* 偶数行背景色（初始生效） */
.table-row.even-row {
  background-color: #f8f9fd;
}

/* 单元格基础样式：左对齐+左右间距（大屏40px/移动端10px）+ 分行 */
.table-cell {
  padding: 16px 40px; /* 大屏左右40px间距（核心） */
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  font-size: 14px;
  line-height: 1.8; /* 优化行高，分行更美观 */
  text-align: left; /* 文字左对齐 */
  display: flex;
  align-items: flex-start; /* 垂直顶部对齐 */
  flex-wrap: wrap; /* 自动换行 */
}

/* 去掉最后一列的右边框 */
.table-cell:last-child {
  border-right: none;
}

/* 列宽分配（按内容重要性调整） */
.cell-1 {
  flex: 0 0 22%; /* 服务类型列：固定22%宽度 */
  min-width: 180px; /* 最小宽度，避免过窄 */
}
.cell-2 {
  flex: 1; /* 描述列：自适应宽度（占剩余空间） */
  min-width: 280px;
}
.cell-3 {
  flex: 0 0 32%; /* 适用场景列：固定32%宽度（预留对勾空间） */
  min-width: 240px;
  align-items: center; /* 对勾与文字垂直居中 */
  gap: 10px; /* 对勾与文字间距（核心：确保紧跟不重叠） */
}

/* 对勾图标：绿色圆形+白色对勾（与图片一致） */
.check-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%; /* 圆形 */
  background-color: #28a745; /* 绿色背景 */
  color: white; /* 白色对勾 */
  font-weight: bold;
  font-size: 12px; /* 对勾大小 */
  line-height: 1; /* 消除垂直偏移 */
  flex-shrink: 0; /* 对勾不缩放，始终在最前面 */
}

/* 最后一列文字容器：限制宽度，分行不超对勾位置 */
.scenarios-text {
  flex: 1;
  max-width: calc(100% - 30px); /* 总宽度 - 对勾宽度(20px) - 间距(10px) */
  line-height: 1.8;
  word-break: break-word; /* 长单词自动换行，避免超出 */
}

/* 平板端适配（768px ~ 992px） */
@media (min-width: 768px) and (max-width: 992px) {
  .table-cell {
    padding: 14px 30px; /* 平板左右30px间距 */
    font-size: 13px;
  }
  .cell-1 {
    flex: 0 0 20%;
    min-width: 160px;
  }
  .cell-3 {
    flex: 0 0 30%;
    min-width: 220px;
    gap: 8px;
  }
  .check-icon {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
  .scenarios-text {
    max-width: calc(100% - 26px); /* 26=18+8 */
  }
}

/* 移动端适配（≤ 768px）：转为卡片式布局 */
@media (max-width: 768px) {
  /* 表头隐藏 */
  .table-header {
    display: none;
  }

  /* 数据行转为块级元素（卡片） */
  .table-row {
    display: block;
    margin-bottom: 18px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  /* 偶数行卡片背景色 */
  .table-row.even-row {
    background-color: #f8f9fd;
  }

  /* 单元格：移动端左右10px间距（核心） */
  .table-cell {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 14px 10px; /* 移动端左右10px间距 */
    border: none;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
    text-align: left;
  }

  /* 最后一个单元格去掉下边框 */
  .table-cell:last-child {
    border-bottom: none;
  }

  /* 列宽限制取消（移动端自适应） */
  .cell-1, .cell-2, .cell-3 {
    flex: none;
    min-width: auto;
    width: 100%;
    align-items: flex-start; /* 移动端对勾与文字顶部对齐 */
    gap: 8px;
  }

  /* 通过 data-label 显示列名（模拟表头） */
  .table-cell::before {
    content: attr(data-label);
    flex: 0 0 auto;
    font-weight: 600;
    color: #2a43c9; /* 列名颜色与表头一致 */
    text-align: left;
    margin-bottom: 8px;
    font-size: 14px;
  }

  /* 移动端最后一列：对勾紧跟文字前 */
  .scenarios-text {
    max-width: calc(100% - 26px); /* 26=18+8 */
  }
  .check-icon {
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
}

/** related-section */
/* 外层容器：仅作用于section内部，整体居中 */
.related-section {
  width: 100%;
  padding: clamp(20px, 3vw, 30px) clamp(15px, 2vw, 20px);
  box-sizing: border-box;
  max-width: 1200px; /* 限制最大宽度，确保2x2布局稳定 */
  margin: 0 auto;
}

/* 标题：居中显示 */
.related-section__title {
  font-size: clamp(1.25rem, 2.5vw, 1.75rem);
  font-weight: 600;
  margin-bottom: clamp(20px, 3vw, 28px);
  color: #2d3748;
  text-align: left;
}

/* 卡片网格：强制两行两列居中布局（核心） */
.related-section__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 固定2列，每列等宽 */
  grid-template-rows: repeat(2, auto); /* 固定2行，高度自适应内容 */
  gap: clamp(16px, 2vw, 24px); /* 卡片间距（水平+垂直一致） */
  justify-items: center; /* 卡片水平居中 */
  align-items: stretch; /* 同一列卡片高度统一 */
}

/* 卡片基础样式：适配网格布局 */
.related-section__card {
  width: 100%;
  max-width: 500px; /* 单个卡片最大宽度，避免过宽 */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background-color: #fff;
  border: 1px solid transparent;
}

/* 卡片hover效果 */
.related-section__card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: rgba(66, 133, 244, 0.3);
}

/* 卡片表头样式 */
.related-section__card-header {
  padding: clamp(12px, 1.5vw, 16px) clamp(16px, 2vw, 20px);
  font-size: clamp(1rem, 1.8vw, 1.125rem);
  font-weight: 600;
  color: white;
  text-align: center;
}

/* 蓝色表头 */
.related-section__card--blue .related-section__card-header {
  background-color: #4285f4;
  background-image: linear-gradient(135deg, #4285f4 0%, #3367d6 100%);
}

/* 深蓝色表头 */
.related-section__card--dark-blue .related-section__card-header {
  background-color: #1a237e;
  background-image: linear-gradient(135deg, #1a237e 0%, #0d1b2a 100%);
}

/* 卡片内容样式 */
.related-section__card-body {
  padding: clamp(16px, 2vw, 20px);
  list-style: none;
  margin: 0;
  color: #4a5568;
  font-size: clamp(0.875rem, 1.4vw, 0.95rem);
  line-height: 1.8;
}

/* 列表项样式 */
.related-section__card-body li {
  position: relative;
  padding-left: clamp(16px, 2vw, 20px);
  margin-bottom: clamp(8px, 1vw, 12px);
}

.related-section__card-body li:last-child {
  margin-bottom: 0;
}

/* 自定义列表圆点 */
.related-section__card-body li::before {
  content: "";
  position: absolute;
  left: 0;
  top: clamp(6px, 1vw, 8px);
  width: clamp(8px, 1.2vw, 10px);
  height: clamp(8px, 1.2vw, 10px);
  border-radius: 50%;
  background-color: #4285f4;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
}
/* 新增：第二列（深蓝色表头）卡片的列表圆点颜色，与表头颜色匹配 */
.related-section__card--dark-blue .related-section__card-body li::before {
  background-color: #1a237e; /* 与深蓝色表头颜色一致 */
  box-shadow: 0 0 0 2px rgba(26, 35, 126, 0.2); /* 外发光也匹配表头颜色 */
}

/* 移动端适配（≤ 768px）：改为两行一列（垂直堆叠） */
@media (max-width: 768px) {
  .related-section__grid {
    grid-template-columns: 1fr; /* 移动端1列 */
    grid-template-rows: repeat(4, auto); /* 4行 */
  }

  .related-section__card {
    max-width: 100%; /* 移动端卡片占满宽度 */
  }

  .related-section__card-body {
    line-height: 1.7;
  }
}


/* Services Process ********************************************************/
/* 以下是你原有的PC端布局代码，完全未改动 */
.services-process {
    padding: 60px 0;
    width: 100%;
}

.services-process_pic {
    width: 100%;
    display:flex;
    flex-wrap: nowrap; /* 强制横向排列 */
    gap: 0;
}

.process-item {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    flex: 1; /* 子项平均分配宽度 */
}

.process-icon {
    display: block;
    margin: 0 100px;
    height: 70px;
}

.process-line {
    display: block;
    border-top: 2px solid #D3D3D3; /* 设置横线的样式 */
    flex: 1; /* 横线占满剩余空间 */
}

.services-process_item {
    display: flex;
}

.process-text-item {
    text-align: center;
    margin: 10px 5px;
}

.process-text-item p {
    text-align: center;
    font-size: 14px;
    margin: 0 5px;
}

/* 图片等比例缩放，填充容器且不畸变 */
.process-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain; 
}

/* 平板适配（同步调整容器大小，保持比例） */
@media (min-width: 769px) and (max-width: 1024px) {
    .process-icon {
        margin: 0 50px;
        /* 平板端可适当缩小容器（可选，保持 100px 也可） */
        /* width: 80px;
        height: 80px; */
    }
}

/* 移动端适配（调整容器大小，适配小屏幕） */
@media (max-width: 768px) {
    .process-icon {
        margin: 0;
        /* 移动端缩小容器，避免占满屏幕宽度 */
        width: 80px;
        height: 80px;
    }

    /* 移动端图片保持等比例缩放 */
    .process-icon img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

/* 重点优化：手机移动端（≤768px）布局，不影响其他尺寸 */
@media (max-width: 768px) {
    /* 1. 图标区域：改为垂直排列（图标+横线上下分布），避免横向拥挤 */
    .services-process_pic {
        flex-direction: column; /* 纵向排列 */
        align-items: center;    /* 水平居中 */
        gap: 15px;              /* 步骤间垂直间距 */
    }

    .process-item {
        width: auto; /* 取消100%宽度，适应内容 */
        flex-direction: column;/* 图标和横线垂直排列 */
        gap: 8px;               /* 图标与横线间距 */
        margin: 0;              /* 清除多余margin */
    }

    /* 2. 图标间距统一，适配垂直布局 */
    .process-icon {
        margin: 0; /* 清除左右大间距，垂直布局无需横向间距 */
    }

    /* 3. 横线改为水平短线条（适配垂直布局的步骤分隔） */
    .process-line {
        width: 40px;    /* 横向短线条，标识步骤连接 */
        margin: 0 auto; /* 水平居中 */
    }

    /* 4. 移除最后一个步骤的横线（避免多余线条） */
    .process-item:last-child .process-line {
        display: none;
    }

    /* 5. 文本区域：改为1列垂直排列，每个文本块占满宽度 */
    .services-process_item {
        flex-direction: column; /* 纵向排列 */
        gap: 25px;              /* 文本块之间的垂直间距 */
        margin-top: 20px;       /* 与图标区域拉开距离 */
    }

    .process-text-item {
        margin: 0; /* 清除原有左右间距 */
        padding: 0 15px; /* 左右内边距，避免贴边 */
        width: 100%; /* 占满屏幕宽度 */
    }

    /* 6. 文本样式优化，提升移动端可读性 */
    .process-text-item h4 {
        font-size: 16px; /* 标题适当放大，突出层级 */
        margin-bottom: 8px;
    }

    .process-text-item p {
        font-size: 13px; /* 正文适配移动端阅读 */
        line-height: 1.6; /* 行高优化，提升可读性 */
        margin: 0;
    }

    /* 7. 图标图片自适应，避免过大溢出 */
    .process-icon img {
        width: 50px; /* 限制图标最大宽度，可根据实际图标尺寸调整 */
        height: auto; /* 保持宽高比 */
    }
}

/* 可选：平板适配（仅影响平板尺寸，不干扰PC端） */
@media (min-width: 769px) and (max-width: 1024px) {
    .process-icon {
        margin: 0 50px;
    }
    .process-line {
        width: 45px;
    }
}

/** service packages section ************************************************************************************/

.service-packages {
    padding: 60px 0;
    background-color: #2444CB;
    width: 100%;
}

.service-packages .section-title h3 {
    font-size: 32px;
    color: white;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
}

/* 父容器：开启flex，确保子元素靠左排列，且不自动换行（保持1/4宽度） */
.packages-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

/* 核心：卡片占父容器1/4宽度，靠左排列 */
.packages-card {
  background-color: #fff;
  border: 2px solid #2962ff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 25%;
  min-width: 25%;
  max-width: 25%;
  box-sizing: border-box;
  margin: 0;
  margin-left: 10px;
  height: 800px;
}

/* 标题区域 */
.package-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.package-title {
  font-size: 16px;
  font-weight: 700;
  color: #212121;
  margin: 0;
}

.package-tag {
  background-color: #ff9e1b;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
}

/* 价格区域 */
.package-price {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.price-label {
  font-size: 14px;
  color: #757575;
  margin-right: 8px;
}

.price-old {
  font-size: 18px;
  color: #9e9e9e;
  text-decoration: line-through;
  margin-right: 8px;
}

.price-new {
  font-size: 22px;
  color: #2962ff;
  font-weight: 700;
}

/* 描述区域 */
.package-desc {
  font-size: 13px;
  color: #616161;
  margin-bottom: 20px;
  line-height: 1.5;
}

/* 按钮区域 */
.package-btn {
  width: 100%;
  background-color: #2962ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;
}

.package-btn:hover {
  background-color: #1976d2;
}

/* -------------- 服务列表优化核心样式 -------------- */
.package-services {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* 列表项：图标+文字横向对齐，间距均匀 */
.service-item {
  display: flex;
  align-items: center; /* 图标与文字顶部对齐（更整洁） */
  margin-bottom: 14px; /* 优化列表项间距，不拥挤 */
  font-size: 13px;
  color: #424242;
  line-height: 1.6; /* 优化行高，换行后更易读 */
}

.service-item:last-child {
  margin-bottom: 0;
}

/* 图标：固定大小+居中，确保所有图标对齐一致 */
.service-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px; /* 优化图标大小，视觉协调 */
  height: 22px;
  margin-right: 12px; /* 图标与文字间距，不贴边 */
  /* border-radius: 50%; */
  color: #2962ff;
  /* background-color: rgba(41, 98, 255, 0.1); */
  /* flex-shrink: 0; */
  font-size: 12px; /* 对勾图标大小适配 */
  font-weight: 700;
}

/* 文字容器：换行自然，避免与图标错位 */
.service-text {
  flex: 1; /* 文字占满剩余宽度，换行不影响图标 */
  word-break: break-word; /* 长单词/长文本自动换行，不溢出卡片 */
}

/* -------------- 移动端适配 -------------- */
@media (max-width: 768px) {
  .packages-grid {
    flex-wrap: wrap;
  }
  .packages-card {
    width: 100%;
    /* min-width: 100%; */
    max-width: 100%;
    margin-bottom: 20px;
    height: auto; /* 保持卡片高度随内容/子元素自适应（核心） */
    min-height: 120px; /* 可选：避免内容过少时卡片塌陷（可按需调整数值） */
    box-sizing: border-box; /* 避免padding撑大宽度，适配移动端 */
    padding: 16px; /* 内边距，避免内容贴边（移动端友好，可调整） */
    display: flex; /* 开启Flex布局，让直接子元素自动撑满高度 */
    flex-direction: column; /* 子元素垂直排列（默认就是column，可省略） */
  }

  /* 移动端服务列表微调 */
  .service-item {
    margin-bottom: 12px;
    font-size: 14px;
  }
  .service-icon {
    width: 24px;
    height: 24px;
    margin-right: 14px;
  }
}

/* 可选：平板适配（仅影响平板尺寸，不干扰PC端） */
@media (min-width: 769px) and (max-width: 1024px) {
    /* 核心：卡片占父容器1/4宽度，靠左排列 */
    .packages-card {
        background-color: #fff;
        border: 2px solid #2962ff;
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        width: 25%;
        min-width: 25%;
        max-width: 25%;
        box-sizing: border-box;
        margin: 0;
        margin-left: 10px;
        height: 1000px;
    }
}
</style>